module.exports = __webpack_public_path__ + "img/bay.69185ccf.png";